import { put, takeLatest, call } from 'redux-saga/effects'

import { UnUsePoint } from '../../../services/orderService'
import {
  UNUSE_POINT,
  UNUSE_POINT_SUCCESS,
  UNUSE_POINT_ERROR
}
  from '../../actions/order'

function * unUsePointSaga (action) {
  try {
    const data = yield call(UnUsePoint, action.payload)

    yield put({
      type: UNUSE_POINT_SUCCESS,
      payload: data
    })
  } catch (error) {
    yield put({
      type: UNUSE_POINT_ERROR, error: error.data
    })
  }
}

export function * unUsePointSagaWatcher () {
  yield takeLatest(UNUSE_POINT, unUsePointSaga)
}
